import store from '../../redux/store';

export function userPrefixedString(suffix: string): string {
  const userId = store.getState()?.user?.user_id;

  return (userId ? `${userId}_` : '') + suffix;
}
